import { render, staticRenderFns } from "./OrganisationRequestsTable.vue?vue&type=template&id=39990bd6&scoped=true"
import script from "./OrganisationRequestsTable.vue?vue&type=script&lang=js"
export * from "./OrganisationRequestsTable.vue?vue&type=script&lang=js"
import style0 from "./OrganisationRequestsTable.vue?vue&type=style&index=0&id=39990bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39990bd6",
  null
  
)

export default component.exports